import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { sha256, sha224 } from 'js-sha256';

function useFetch(req, initialState = null, reload = { endPoint: null, isClicked: 0 }) {
	/* const handleClick = () => {
        setEndpoint("https://api.github.com/users?since=135");
      }; */
	// request interceptor
	/*     axios.interceptors.request.use(
    config => {
        let url = config.url ;
        let method = config.method;
        let params = "URL:"+ url + ",METHOD:" + method.toUpperCase() + `,API_KEY:${process.env.GATSBY_API_KEY}`
        console.log("params :",params)
        console.log("sha256(params) :",sha256(params))
        config.headers['Authorization'] = sha256(params);
        config.headers['Content-Type'] = 'application/json'; 
        return config;
    },
    error => {
        Promise.reject(error)
    }); */
	const [res, setRes] = useState({
		data: initialState,
		complete: false,
		loading: false,
		error: false,
		endPoint: req,
	});

	const url = `${process.env.GATSBY_API_URL}/` + req;
	//const url = `/${req}`;
	//const req = `http://localhost:1337/`+endPoint
	//const req = `${process.env.GATSBY_API_URL}/`+endPoint

	const fetchData = async () => {
		const  response =  await axios(url);
		return response;
	};

	const makeResData= (response)=>{
		const data = response.data.data;
		return Array.isArray(data)? data.map(el=>({...el.attributes,id:el.id})):{...data.attributes,id:data.id};
	}



	/*     console.log("localStorageToken : ",localStorageToken)
    if (localStorageToken && localStorageToken.length > 0) {
        
      } else {
        fetchToken()
            .then(res =>

                localStorage.setItem('token', res.data.jwt)
            )
            .catch(() =>
                console.log("error in store token")
            );
      } */

	useEffect(() => {
		if (reload.endPoint === null || req === reload.endPoint) {
			setRes({
				data: initialState,
				loading: true,
				error: false,
				complete: false,
				endPoint: req,
			});
			fetchData()
				.then((response) =>
				{
					setRes({
						data: makeResData(response),
						loading: false,
						error: false,
						complete: true,
						endPoint: req,
					});
		})
				.catch(() =>
					setRes({
						data: initialState,
						loading: false,
						error: true,
						complete: true,
						endPoint: req,
					}),
				);
		}
	}, [req, reload]);
	return res;
}

export default useFetch;
